import { createRoot } from 'react-dom/client';
import { App } from './Components/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';

// Bootstrap 4's JS plugins expect a global jQuery.
window.$ = window.jQuery = $;

import 'bootstrap';
import './Styles/app.scss';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
